import * as core from '../../../../../../../core'
import * as changeImpactPhase from '../change-impact-phase'

export const RESOURCE = {
  payload: {
    description: 'Bio Demo',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactPhase.RESOURCE.payload.partialId,
    }),
    id: 'Bio Demo',
    name: 'Bio Demo',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
